import React from 'react';

const FormContext = React.createContext({
  values: {},
  errors: {},
});

export default FormContext;
